import React, { useContext } from "react";
import { NavContext } from "../../context/nav";
import { IHeaderComposition } from "../../interfaces/IHeader";
import {
  Container,
  Humberger,
  Inner,
  Item,
  List,
  Nav,
  Page,
  Toggler,
} from "./styles/Header";

const Header: React.FC & IHeaderComposition = ({ children, ...restProps }) => {
  const { NavOpen } = useContext(NavContext);
  return (
    <Container hiddenNav={!NavOpen} {...restProps}>
      {children}
    </Container>
  );
};

Header.Toggler = function HeaderToggler({ children, ...restProps }) {
  const { setNavOpen } = useContext(NavContext);
  return (
    <Toggler
      type='button'
      onClick={() => setNavOpen((showPrev) => !showPrev)}
      {...restProps}
    >
      {children}
    </Toggler>
  );
};

Header.Humberger = function HeaderHumberger({ ...restProps }) {
  return <Humberger {...restProps} />;
};

Header.Nav = function HeaderNav({ children, ...restProps }) {
  return <Nav {...restProps}>{children}</Nav>;
};

Header.Inner = function HeaderInner({ children, ...restProps }) {
  return (
    <Inner {...restProps}>
      <List>{children}</List>
    </Inner>
  );
};

Header.Page = function HeaderPage({ name, children, ...restProps }) {
  const { setNavOpen } = useContext(NavContext);

  return (
    <Item onClick={() => setNavOpen((showPrev) => !showPrev)} {...restProps}>
      <Page to={name}>{children}</Page>
    </Item>
  );
};

export default Header;
